export const WC_MENU_OPTIONS = {};
